var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronExpand = function SvgChevronExpand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-24": 14,
    viewBox: "0 0 13.6 17.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.832 10.54a.766.766 0 0 1 .443 1.343l-6 5a.75.75 0 0 1-1 0l-6-5a.751.751 0 0 1 .48-1.33.78.78 0 0 1 .48.17l5.52 4.6 5.52-4.6a.76.76 0 0 1 .557-.184M6.766 0a.75.75 0 0 1 .5.191l6 5a.75.75 0 0 1-.48 1.33.78.78 0 0 1-.48-.17l-5.52-4.6-5.52 4.6a.766.766 0 1 1-1-1.16l6-5a.75.75 0 0 1 .5-.191"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronExpand);
export default ForwardRef;